import {escapeHtmlSymbols} from '../../atUtils'
import messageResource from '../../messageResource'
import {ReportGroupingLevel} from '../constants'

function ChartGroupingLevelSelectorFillingStrategy() {}

ChartGroupingLevelSelectorFillingStrategy.prototype.init = function(isUGREnabled, isBTYEnabled, isTZGEnabled, initiallySelectedGroupingLevel) {
    this.isUGREnabled = isUGREnabled
    this.isTZGEnabled = isTZGEnabled
    this.isBTYEnabled = isBTYEnabled
    this.initiallySelectedGroupingLevel = initiallySelectedGroupingLevel

    return this
}

ChartGroupingLevelSelectorFillingStrategy.prototype.fillGroupingLevelListSelector = function( listSelector )
{
    // abstract
};

ChartGroupingLevelSelectorFillingStrategy.prototype.addUsersItem = function(listSelector) {
    this.addItem(listSelector, messageResource.getMessage("report.common.users"), ReportGroupingLevel.USER)
}

ChartGroupingLevelSelectorFillingStrategy.prototype.addUserGroupsItemIfNeeded = function( listSelector )
{
    if ( this.isUGREnabled || this.initiallySelectedGroupingLevel === ReportGroupingLevel.USER_GROUP )
        this.addItem( listSelector, messageResource.getMessage( "common.User_Groups" ), ReportGroupingLevel.USER_GROUP );
};

ChartGroupingLevelSelectorFillingStrategy.prototype.addTimeZoneGroupsItemIfNeeded = function( listSelector )
{
    if ( this.isTZGEnabled || this.initiallySelectedGroupingLevel === ReportGroupingLevel.TIME_ZONE_GROUP )
        this.addItem( listSelector, messageResource.getMessage( "common.Time_Zone_Groups" ), ReportGroupingLevel.TIME_ZONE_GROUP );
};

ChartGroupingLevelSelectorFillingStrategy.prototype.addLeaveTypesItem = function( listSelector )
{
        this.addItem( listSelector, messageResource.getMessage( "common.Leave_Types" ), ReportGroupingLevel.LEAVE_TYPE );
};

ChartGroupingLevelSelectorFillingStrategy.prototype.addCustomersItem = function( listSelector )
{
    this.addItem( listSelector, messageResource.getMessage( "common.Customers" ), ReportGroupingLevel.CUSTOMER );
};

ChartGroupingLevelSelectorFillingStrategy.prototype.addProjectsItem = function( listSelector )
{
    this.addItem( listSelector, messageResource.getMessage( "common.Projects" ), ReportGroupingLevel.PROJECT );
};

ChartGroupingLevelSelectorFillingStrategy.prototype.addTypesOfWorkItemIfNeeded = function( listSelector )
{
    if ( this.isBTYEnabled || this.initiallySelectedGroupingLevel === ReportGroupingLevel.BILLING_TYPE )
        this.addItem( listSelector, messageResource.getMessage( "report.common.billing_types" ), ReportGroupingLevel.BILLING_TYPE );
};

ChartGroupingLevelSelectorFillingStrategy.prototype.addDaysItem = function( listSelector )
{
    this.addItem( listSelector, messageResource.getMessage( "report.common.dates" ), ReportGroupingLevel.DATE );
};

ChartGroupingLevelSelectorFillingStrategy.prototype.addWeeksItem = function( listSelector )
{
    this.addItem( listSelector, messageResource.getMessage( "report.common.weeks" ), ReportGroupingLevel.WEEK );
};

ChartGroupingLevelSelectorFillingStrategy.prototype.addMonthsItem = function( listSelector )
{
    this.addItem( listSelector, messageResource.getMessage( "report.common.months" ), ReportGroupingLevel.MONTH );
};

ChartGroupingLevelSelectorFillingStrategy.prototype.addItem = function( listSelector, text, value )
{
    listSelector.addItems( [ { text: escapeHtmlSymbols( text ), value: value } ] );
};

export default ChartGroupingLevelSelectorFillingStrategy


// WEBPACK FOOTER //
// ./web/js/reports/charts/ChartGroupingLevelSelectorFillingStrategy.js